<template>
  <div class="mis-permisos">
    <b-card no-body class="shadow-sm border-0 main-card">
      <!-- Encabezado con información del usuario -->
      <div class="text-white p-4 rounded-top">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
          <div class="mt-3 mt-md-0">
            <span class="h2 font-weight-bold">Accesos Permitidos</span>
            <b-badge variant="light" class="p-2 badge-role">
            </b-badge>
          </div>
        </div>
      </div>

      <b-card-body class="p-0">
        <!-- Estado de carga -->
        <div v-if="cargando" class="text-center py-5">
          <b-spinner variant="primary" label="Cargando..."></b-spinner>
          <p class="mt-3">Cargando tus permisos...</p>
        </div>

        <!-- Sin permisos -->
        <div v-else-if="!tienePermisos" class="text-center py-5">
          <div class="empty-state">
            <i class="fas fa-lock fa-3x text-muted mb-3"></i>
            <h4>No tienes permisos asignados</h4>
            <p class="text-muted">No se encontraron permisos activos para tu usuario.</p>

            <!-- Herramientas de depuración -->
            <div class="mt-4">
              <b-button variant="outline-secondary" size="sm" @click="mostrarDebug = !mostrarDebug">
                {{ mostrarDebug ? 'Ocultar' : 'Mostrar' }} información de depuración
              </b-button>

              <div v-if="mostrarDebug" class="mt-3 text-left">
                <b-card no-body>
                  <b-tabs content-class="mt-3" pills card>
                    <b-tab title="Estado" active>
                      <b-list-group flush>
                        <b-list-group-item>
                          <strong>Usando mapa de rol:</strong> {{ usandoMapaDeRol ? 'Sí' : 'No' }}
                        </b-list-group-item>
                        <b-list-group-item>
                          <strong>Rol:</strong> {{ rolDescripcion || 'No definido' }}
                        </b-list-group-item>
                        <b-list-group-item>
                          <strong>ID de Rol:</strong> {{ rolId || 'No definido' }}
                        </b-list-group-item>
                        <b-list-group-item>
                          <strong>Permisos en mapa:</strong> {{ Object.keys(permisosMap).length }}
                        </b-list-group-item>
                        <b-list-group-item>
                          <strong>Estructura de permisos cargada:</strong> {{ permisosData ? 'Sí' : 'No' }}
                        </b-list-group-item>
                      </b-list-group>
                    </b-tab>

                    <b-tab title="Mapa de Permisos" v-if="Object.keys(permisosMap).length > 0">
                      <div class="mb-2">
                        <b-form-input v-model="filtroDebug" placeholder="Filtrar permisos..." size="sm"></b-form-input>
                      </div>

                      <div style="max-height: 300px; overflow-y: auto;">
                        <b-table :items="mapaPermisosArray" :fields="['ruta', 'valor']" :filter="filtroDebug"
                          :per-page="10" :current-page="paginaDebug" small striped responsive>
                          <template #cell(valor)="data">
                            <b-badge :variant="data.value === 1 ? 'success' : 'secondary'">
                              {{ data.value === 1 ? 'Activo' : 'Inactivo' }}
                            </b-badge>
                          </template>
                        </b-table>

                        <div class="d-flex justify-content-center mt-2">
                          <b-pagination v-model="paginaDebug" :total-rows="mapaPermisosArray.length" :per-page="10"
                            size="sm"></b-pagination>
                        </div>
                      </div>
                    </b-tab>

                    <b-tab title="Estructura" v-if="permisosData">
                      <p class="text-muted small">Mostrando primeros 5 grupos de la estructura</p>
                      <pre class="bg-light p-2 rounded" style="max-height: 300px; overflow-y: auto;">{{ JSON.stringify(permisosData.slice(0,
                        5), null, 2) }}</pre>
                    </b-tab>
                  </b-tabs>
                </b-card>
              </div>
            </div>
          </div>
        </div>

        <!-- Con permisos -->
        <div v-else>
          <!-- Resumen y filtros -->
          <div class="p-4 ">
            <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
              <div class="mb-3 mb-md-0">
                <span class="h5  font-weight-bold mb-1">Resumen de accesos</span>
                <p class="mb-0 text-muted">
                  Tienes acceso a <b>{{ totalPermisosActivos }}</b> funcionalidades en <b>{{ totalGruposActivos }}</b>
                  áreas del
                  sistema.
                </p>
              </div>
              <div class="d-flex">
                <b-input-group size="sm" class="mr-2" style="width: 200px;">
                  <b-form-input v-model="filtroTexto" placeholder="Buscar permiso..."
                    @input="filtrarPermisos"></b-form-input>
                  <b-input-group-append v-if="filtroTexto">
                    <b-button variant="outline-secondary" @click="limpiarFiltro">
                      <i class="fas fa-times"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <b-dropdown right text="Opciones" size="sm" variant="outline-secondary">
                  <b-dropdown-item @click="mostrarRutas = !mostrarRutas">
                    <i :class="['fas', mostrarRutas ? 'fa-eye-slash' : 'fa-eye', 'mr-2']"></i>
                    {{ mostrarRutas ? 'Ocultar rutas' : 'Mostrar rutas' }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="expandirTodos">
                    <i class="fas fa-expand-arrows-alt mr-2"></i> Expandir todos
                  </b-dropdown-item>
                  <b-dropdown-item @click="contraerTodos">
                    <i class="fas fa-compress-arrows-alt mr-2"></i> Contraer todos
                  </b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item @click="mostrarDebug = !mostrarDebug">
                    <i class="fas fa-bug mr-2"></i> {{ mostrarDebug ? 'Ocultar' : 'Mostrar' }} depuración
                  </b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                </b-dropdown>
              </div>
            </div>

            <!-- Panel de depuración -->
            <b-collapse v-model="mostrarDebug" class="mt-3">
              <b-card class="mb-0">
                <h6>Información de depuración</h6>
                <b-list-group flush>
                  <b-list-group-item>
                    <strong>Usando mapa de rol:</strong> {{ usandoMapaDeRol ? 'Sí' : 'No' }}
                  </b-list-group-item>
                  <b-list-group-item>
                    <strong>Permisos en mapa:</strong> {{ Object.keys(permisosMap).length }}
                  </b-list-group-item>
                  <b-list-group-item>
                    <strong>Permisos mostrados:</strong> {{ totalPermisosActivos }}
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-collapse>
          </div>

          <!-- Vista de permisos -->
          <div class="p-4">
            <div v-if="filtroActivo && gruposConPermisosFiltrados.length === 0" class="text-center py-4">
              <i class="fas fa-search fa-2x text-muted mb-3"></i>
              <h5>No se encontraron resultados</h5>
              <p class="text-muted">No hay permisos que coincidan con "{{ filtroTexto }}"</p>
              <b-button size="sm" variant="outline-primary" @click="limpiarFiltro">Limpiar búsqueda</b-button>
            </div>

            <div v-else>
              <b-alert v-if="filtroActivo" show variant="info"
                class="d-flex align-items-center justify-content-between">
                <span>
                  <i class="fas fa-filter mr-2"></i>
                  Mostrando {{ totalPermisosFiltrados }} permisos que coinciden con "{{ filtroTexto }}"
                </span>
                <b-button size="sm" variant="outline-info" @click="limpiarFiltro">
                  <i class="fas fa-times mr-1"></i> Limpiar
                </b-button>
              </b-alert>

              <!-- Acordeón de grupos -->
              <b-accordion v-model="grupoActivo" class="permisos-accordion">
                <b-card v-for="(grupo, grupoIndex) in gruposConPermisosMostrados" :key="'grupo-' + grupoIndex" no-body
                  class="mb-3 border grupo-card">
                  <b-card-header :id="'grupo-header-' + grupoIndex" role="tab"
                    class="d-flex align-items-center py-3 px-4" @click="toggleGrupo(grupoIndex)">
                    <div class="grupo-icon mr-3">
                      <i v-if="!grupo.icono" class="fas fa-folder"></i>
                      <b-img v-else :src="grupo.icono" width="24" height="24" :alt="grupo.titulo"></b-img>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="mb-0 d-flex align-items-center">
                        {{ grupo.titulo }}
                        <b-badge variant="primary" pill class="ml-2">{{ contarPermisosGrupo(grupo) }}</b-badge>
                      </h5>
                    </div>
                    <div>
                      <i :class="['fas', grupoActivo === grupoIndex ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
                    </div>
                  </b-card-header>

                  <b-collapse :id="'grupo-collapse-' + grupoIndex" :visible="grupoActivo === grupoIndex"
                    accordion="permisos-accordion" role="tabpanel">
                    <b-card-body class="p-0">
                      <div v-for="(subGrupo, subGrupoIndex) in grupo.subGrupos"
                        :key="'subgrupo-' + grupoIndex + '-' + subGrupoIndex" class="subgrupo-section">
                        <div class="subgrupo-header px-4 py-2 ">
                          <span class="h6 mb-0">{{ subGrupo.titulo }}</span>
                        </div>

                        <b-list-group flush>
                          <b-list-group-item v-for="(permiso, permisoIndex) in subGrupo.permisos"
                            :key="'permiso-' + grupoIndex + '-' + subGrupoIndex + '-' + permisoIndex"
                            class="d-flex align-items-center py-3 px-4 permiso-item">
                            <div class="permiso-icon mr-3">
                              <i class="fas fa-check-circle text-success"></i>
                            </div>
                            <div>
                              <div class="font-weight-bold">{{ permiso.titulo }}</div>
                              <small v-if="permiso.descripcion" class="text-muted d-block">{{ permiso.descripcion
                              }}</small>
                              <small v-if="mostrarRutas" class="d-block text-muted mt-1">
                                <code>{{ permiso.ruta }}</code>
                              </small>
                            </div>
                          </b-list-group-item>
                        </b-list-group>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </b-accordion>

              <!-- Paginación si hay muchos grupos -->
              <div v-if="totalPaginas > 1" class="d-flex justify-content-center mt-4">
                <b-pagination v-model="paginaActual" :total-rows="gruposConPermisosFiltrados.length"
                  :per-page="gruposPorPagina" aria-controls="grupos-permisos" align="center"></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      usuario: {},
      permisosData: null,
      permisosMap: {},
      cargando: true,
      tienePermisos: false,
      totalPermisosActivos: 0,
      totalGruposActivos: 0,
      gruposConPermisos: [],
      usandoMapaDeRol: false,
      rolDescripcion: '',
      rolId: null,
      mostrarRutas: false,

      // Nuevas propiedades para el diseño mejorado
      grupoActivo: 0, // Grupo expandido por defecto
      filtroTexto: '',
      filtroActivo: false,
      gruposConPermisosFiltrados: [],
      totalPermisosFiltrados: 0,

      // Paginación
      paginaActual: 1,
      gruposPorPagina: 10,

      // Depuración
      mostrarDebug: false,
      filtroDebug: '',
      paginaDebug: 1
    };
  },

  computed: {
    gruposConPermisosMostrados() {
      const grupos = this.filtroActivo ? this.gruposConPermisosFiltrados : this.gruposConPermisos;
      const inicio = (this.paginaActual - 1) * this.gruposPorPagina;
      const fin = inicio + this.gruposPorPagina;
      return grupos.slice(inicio, fin);
    },

    totalPaginas() {
      const grupos = this.filtroActivo ? this.gruposConPermisosFiltrados : this.gruposConPermisos;
      return Math.ceil(grupos.length / this.gruposPorPagina);
    },

    mapaPermisosArray() {
      return Object.entries(this.permisosMap).map(([ruta, valor]) => ({
        ruta,
        valor
      }));
    }
  },

  async mounted() {
    // Obtener información del usuario actual
    this.usuario = JSON.parse(localStorage.getItem("setPersonaAct")) || {};

    // Asegurarse de que el rol exista
    if (this.usuario && this.usuario.rol && this.usuario.rol.id) {
      this.rolId = this.usuario.rol.id;
    } else {
      console.error("No se pudo obtener el ID del rol del usuario");
    }

    // Cargar datos
    await this.cargarDatos();

    // Procesar permisos solo si tenemos datos
    if (this.permisosData && Object.keys(this.permisosMap).length > 0) {
      this.procesarPermisos();
    } else {
      console.error("No se pudieron cargar los datos necesarios para procesar permisos");
      this.cargando = false;
      this.tienePermisos = false;
    }
  },

  methods: {
    async cargarDatos() {
      try {
        // Cargar estructura de permisos
        let resEstructura = await this.$store.dispatch("hl_get", {
          path: "RegistrosJsonControlAccesos/GetLatestJson"
        });

        if (resEstructura && resEstructura.registroJson) {
          try {
            let cleanedJsonString = resEstructura.registroJson.replace(/\\"/g, '"').replace(/\\u([0-9a-fA-F]{4})/g, '\\u$1');
            const parsedJson = JSON.parse(cleanedJsonString);
            this.permisosData = parsedJson.data;
            console.log("Estructura de permisos cargada:", this.permisosData.length, "grupos");
          } catch (parseError) {
            console.error("Error al parsear JSON de permisos:", parseError);
            this.permisosData = null;
          }
        }

        // Cargar mapa de permisos del usuario
        let resPermisos = await this.$store.getters.fetchGet({
          path: "Persona/GetPersonaById/" + this.usuario.id,
        });

        let personaData = await resPermisos.json();
        console.log("Datos de persona cargados:", personaData);

        // Verificar si la persona tiene un mapa de permisos válido
        let tieneMapaPersona = false;

        if (personaData && personaData.mapa && personaData.mapa !== 'null') {
          try {
            const mapaPersona = JSON.parse(personaData.mapa);
            // Verificar que el mapa tenga al menos un permiso
            if (Object.keys(mapaPersona).length > 0) {
              this.permisosMap = mapaPersona;
              this.usandoMapaDeRol = false;
              tieneMapaPersona = true;
              console.log("Usando mapa de permisos del usuario:", Object.keys(this.permisosMap).length, "permisos");
            } else {
              console.log("El mapa de permisos del usuario está vacío");
            }
          } catch (error) {
            console.error("Error al parsear mapa de permisos de persona:", error);
          }
        }

        // Si no tiene mapa de persona válido, cargar el mapa del rol
        if (!tieneMapaPersona) {
          console.log("Usuario sin mapa de permisos propio, cargando mapa del rol");

          if (this.rolId) {
            await this.cargarMapaDeRol(this.rolId);
          } else if (personaData && personaData.rol && personaData.rol.id) {
            this.rolId = personaData.rol.id;
            await this.cargarMapaDeRol(personaData.rol.id);
          } else {
            console.error("No se pudo obtener el ID del rol");
            this.permisosMap = {};
            this.usandoMapaDeRol = false;
          }
        }

        this.cargando = false;
      } catch (error) {
        console.error("Error al cargar datos:", error);
        this.cargando = false;
      }
    },

    async cargarMapaDeRol(rolId) {
      try {
        console.log("Cargando mapa de permisos del rol:", rolId);

        // Obtener el mapa de permisos del rol
        let resRol = await this.$store.getters.fetchGet({
          path: "Rol/GetRol/" + rolId,
        });

        let rolData = await resRol.json();
        console.log("Datos del rol cargados:", rolData);

        if (rolData) {
          // Guardar la descripción del rol
          this.rolDescripcion = rolData.descripcion || 'Rol sin descripción';

          // Verificar si el rol tiene un mapa de permisos
          if (rolData.mapa && rolData.mapa !== 'null') {
            try {
              // Asegurarse de que el mapa sea un objeto JSON válido
              let mapaRol;

              // Si ya es un objeto, usarlo directamente
              if (typeof rolData.mapa === 'object') {
                mapaRol = rolData.mapa;
              } else {
                // Si es un string, parsearlo
                mapaRol = JSON.parse(rolData.mapa);
              }

              // Verificar que el mapa tenga permisos
              if (Object.keys(mapaRol).length > 0) {
                this.permisosMap = mapaRol;
                this.usandoMapaDeRol = true;
                console.log("Mapa de permisos del rol cargado correctamente:", Object.keys(this.permisosMap).length, "permisos");

                // Mostrar los primeros 5 permisos para depuración
                const primeros5 = Object.entries(this.permisosMap).slice(0, 5);
                console.log("Primeros 5 permisos del rol:", primeros5);

                // Asegurarse de que se procesen los permisos después de cargar el mapa
                return true;
              } else {
                console.warn("El mapa de permisos del rol está vacío");
              }
            } catch (error) {
              console.error("Error al parsear mapa de permisos del rol:", error);
            }
          } else {
            console.warn("El rol no tiene mapa de permisos");
          }
        } else {
          console.warn("No se encontraron datos del rol");
        }

        // Si llegamos aquí, no se pudo cargar el mapa del rol correctamente
        this.permisosMap = {};
        this.usandoMapaDeRol = false;
        return false;
      } catch (error) {
        console.error("Error al cargar mapa de rol:", error);
        this.permisosMap = {};
        this.usandoMapaDeRol = false;
        return false;
      }
    },

    procesarPermisos() {
      if (!this.permisosData || !this.permisosMap || Object.keys(this.permisosMap).length === 0) {
        console.warn("No se pueden procesar permisos: faltan datos necesarios");
        this.tienePermisos = false;
        return;
      }

      console.log("Procesando permisos con mapa de", Object.keys(this.permisosMap).length, "permisos");

      // Inicializar contador de permisos activos total
      this.totalPermisosActivos = 0;
      this.totalGruposActivos = 0;
      let gruposConPermisos = [];

      // Recorrer la estructura de permisos y filtrar solo los activos
      this.permisosData.forEach(grupo => {
        let grupoTienePermisos = false;
        let subGruposActivos = [];

        grupo.subGrupo.forEach(subGrupo => {
          // Array para almacenar los permisos activos de este subgrupo
          let permisosSubgrupo = [];

          // Procesar items principales
          subGrupo.items.forEach(item => {
            // Verificar si el usuario tiene acceso a este permiso específico
            const tieneAcceso = this.verificarPermiso(item.ruta);

            if (tieneAcceso) {
              // Verificar si el permiso es exclusivo de superAdmin
              if (!item.superAdmin || (this.usuario.rol && this.usuario.rol.nivel === 4)) {
                permisosSubgrupo.push({
                  titulo: item.titulo,
                  ruta: item.ruta,
                  descripcion: item.descripcion || null
                });
              }
            }

            // Procesar subitems si existen
            if (item.subItems) {
              item.subItems.forEach(subItem => {
                const tieneAccesoSubItem = this.verificarPermiso(subItem.ruta);

                if (tieneAccesoSubItem) {
                  // Verificar si el permiso es exclusivo de superAdmin
                  if (!subItem.superAdmin || (this.usuario.rol && this.usuario.rol.nivel === 4)) {
                    permisosSubgrupo.push({
                      titulo: subItem.titulo,
                      ruta: subItem.ruta,
                      descripcion: subItem.descripcion || `Parte de ${item.titulo}`
                    });
                  }
                }
              });
            }
          });

          // Si hay permisos activos en este subgrupo, añadirlo
          if (permisosSubgrupo.length > 0) {
            subGruposActivos.push({
              titulo: subGrupo.titulo,
              permisos: permisosSubgrupo
            });

            grupoTienePermisos = true;
            // Incrementar el contador total de permisos activos
            this.totalPermisosActivos += permisosSubgrupo.length;
          }
        });

        // Si el grupo tiene permisos, añadirlo al resultado
        if (grupoTienePermisos) {
          gruposConPermisos.push({
            titulo: grupo.titulo,
            icono: grupo.icono,
            subGrupos: subGruposActivos
          });

          this.totalGruposActivos++;
        }
      });

      this.gruposConPermisos = gruposConPermisos;
      this.gruposConPermisosFiltrados = [...gruposConPermisos];
      this.tienePermisos = this.totalPermisosActivos > 0;

      console.log("Permisos procesados:", this.totalPermisosActivos, "permisos activos en", this.totalGruposActivos, "grupos");

      if (!this.tienePermisos) {
        console.warn("No se encontraron permisos activos para el usuario");
      }
    },

    verificarPermiso(ruta) {
      // Si no hay mapa de permisos, no hay permisos
      if (!this.permisosMap || Object.keys(this.permisosMap).length === 0) {
        return false;
      }

      // Verificar diferentes formatos de ruta
      // 1. Ruta exacta como está
      if (this.permisosMap[ruta] === 1) {
        return true;
      }

      // 2. Ruta con slash al inicio
      const rutaConSlash = ruta.startsWith('/') ? ruta : '/' + ruta;
      if (this.permisosMap[rutaConSlash] === 1) {
        return true;
      }

      // 3. Ruta sin slash al inicio
      const rutaSinSlash = ruta.startsWith('/') ? ruta.substring(1) : ruta;
      if (this.permisosMap[rutaSinSlash] === 1) {
        return true;
      }

      // 4. Ruta con /helex/ al inicio
      const rutaConHelex = '/helex/' + rutaSinSlash;
      if (this.permisosMap[rutaConHelex] === 1) {
        return true;
      }

      // 5. Ruta con helex/ al inicio (sin slash inicial)
      const rutaConHelexSinSlash = 'helex/' + rutaSinSlash;
      if (this.permisosMap[rutaConHelexSinSlash] === 1) {
        return true;
      }

      return false;
    },

    tienePermiso(ruta) {
      return this.verificarPermiso(ruta);
    },

    // Métodos para el nuevo diseño
    toggleGrupo(index) {
      this.grupoActivo = this.grupoActivo === index ? null : index;
    },

    expandirTodos() {
      // No hacemos nada, ya que estamos usando un acordeón que solo permite un grupo abierto a la vez
      // Pero podríamos cambiar esto si se desea
    },

    contraerTodos() {
      this.grupoActivo = null;
    },

    filtrarPermisos() {
      if (!this.filtroTexto.trim()) {
        this.limpiarFiltro();
        return;
      }

      const textoBusqueda = this.filtroTexto.toLowerCase().trim();
      this.filtroActivo = true;

      // Filtrar grupos y subgrupos que contienen permisos que coinciden con el texto
      const gruposFiltrados = this.gruposConPermisos.map(grupo => {
        // Crear una copia del grupo para no modificar el original
        const grupoFiltrado = { ...grupo };

        // Filtrar subgrupos
        grupoFiltrado.subGrupos = grupo.subGrupos.map(subGrupo => {
          // Crear una copia del subgrupo
          const subGrupoFiltrado = { ...subGrupo };

          // Filtrar permisos
          subGrupoFiltrado.permisos = subGrupo.permisos.filter(permiso =>
            permiso.titulo.toLowerCase().includes(textoBusqueda) ||
            (permiso.descripcion && permiso.descripcion.toLowerCase().includes(textoBusqueda)) ||
            permiso.ruta.toLowerCase().includes(textoBusqueda)
          );

          return subGrupoFiltrado;
        }).filter(subGrupo => subGrupo.permisos.length > 0);

        return grupoFiltrado;
      }).filter(grupo => grupo.subGrupos.length > 0);

      this.gruposConPermisosFiltrados = gruposFiltrados;
      this.paginaActual = 1;

      // Contar total de permisos filtrados
      this.totalPermisosFiltrados = gruposFiltrados.reduce((total, grupo) => {
        return total + grupo.subGrupos.reduce((subtotal, subGrupo) => {
          return subtotal + subGrupo.permisos.length;
        }, 0);
      }, 0);
    },

    limpiarFiltro() {
      this.filtroTexto = '';
      this.filtroActivo = false;
      this.gruposConPermisosFiltrados = [...this.gruposConPermisos];
      this.paginaActual = 1;
    },

    contarPermisosGrupo(grupo) {
      return grupo.subGrupos.reduce((total, subGrupo) => {
        return total + subGrupo.permisos.length;
      }, 0);
    },

  }
};
</script>

<style scoped>
.mis-permisos {
  max-width: 1200px;
  margin: 0 auto;
}

.main-card {
  border-radius: 8px;
  overflow: hidden;
}

.badge-role {
  font-size: 0.85rem;
  font-weight: 600;
}

.permisos-accordion .card-header {
  cursor: pointer;
  transition: background-color 0.2s;
}

.permisos-accordion .card-header:hover {
  background-color: #f8f9fa;
}

.grupo-card {
  border-radius: 6px;
  overflow: hidden;
  transition: box-shadow 0.2s;
}

.grupo-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.grupo-icon,
.permiso-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: rgba(0, 123, 255, 0.1);
}

.permiso-icon {
  background-color: rgba(40, 167, 69, 0.1);
}

.subgrupo-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.permiso-item {
  transition: background-color 0.2s;
}

.permiso-item:hover {
  background-color: #f8f9fa;
}

.empty-state {
  padding: 3rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Estilos para impresión */
@media print {
  .mis-permisos {
    max-width: 100%;
  }

  .main-card {
    border: none !important;
    box-shadow: none !important;
  }

  .bg-primary {
    background-color: #f8f9fa !important;
    color: #212529 !important;
    padding: 1rem !important;
  }

  .btn,
  .pagination,
  .dropdown,
  .input-group {
    display: none !important;
  }

  .grupo-card {
    page-break-inside: avoid;
    margin-bottom: 1.5rem !important;
    border: 1px solid #dee2e6 !important;
  }

  .card-header {
    background-color: #f8f9fa !important;
  }

  .permiso-item {
    page-break-inside: avoid;
  }
}
</style>